export default __webpack_public_path__ + "static/media/flappybird.188e8b1e.jpg";